import React from 'react';
import {Outlet} from 'react-router-dom';

const Review: React.FC = () => {
  return <Outlet />;
};

export default Review;
